import { render } from "./CoordinatorsListingModal.vue?vue&type=template&id=7720af2e"
import script from "./CoordinatorsListingModal.vue?vue&type=script&lang=js"
export * from "./CoordinatorsListingModal.vue?vue&type=script&lang=js"

import "./CoordinatorsListingModal.vue?vue&type=style&index=0&id=7720af2e&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__